import { createSlice } from "@reduxjs/toolkit";
const initialState = { history_state: [] };

const historyReducer = createSlice({
  name: "historyReducer",
  initialState,
  reducers: {
    historyState(state, action) {
      state.history_state = action.payload;
    },
  },
});
export const { historyState } = historyReducer.actions;
export default historyReducer.reducer;
